import { render, staticRenderFns } from "./BetgameFAQ.vue?vue&type=template&id=791a0aca&scoped=true"
import script from "./BetgameFAQ.vue?vue&type=script&lang=js"
export * from "./BetgameFAQ.vue?vue&type=script&lang=js"
import style0 from "./BetgameFAQ.vue?vue&type=style&index=0&id=791a0aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a0aca",
  null
  
)

export default component.exports